import {createBrowserRouter} from "react-router-dom";

// Dashboard
import Layout from "../layout/Layout";
import Home from "../Page/Home/Home";

// Auth
import NotFound from "../Auth/NotFound";
import Login from "../Auth/Login";
import Error from "../Auth/Error";
import Register from "../Auth/Register";
import NewPassword from "../Auth/NewPassword";
import LockScreen from "../Auth/LockScreen";
import Verification from "../Auth/Verification";
import ProductDetails from "../Page/Products/ProductDetails/ProductDetails";
import Categories from "../Page/Categories/Categories";
import InnovationHub from "../Page/InnovationHub/InnovationHub";
import Newsroom from "../Page/Newsroom/Newsroom";
import Career from "../Page/Career/Career";
import NewProduct from "../Page/Products/NewProduct/NewProduct";
import CareerDetails from "../Page/Career/CareerDetails/CareerDetails";
import CreateNew from "../Page/Career/CreateNew/CreateNew";
import InnovationDetails from "../Page/InnovationHub/InnovationDetails/InnovationDetails";
import InnovationCreate from "../Page/InnovationHub/InnovationCreate/InnovationCreate";
import NewsroomDetails from "../Page/Newsroom/NewsroomDetails/NewsroomDetails";
import NewsroomCreate from "../Page/Newsroom/NewroomCreate/NewroomCreate";
import Inbox from "../Page/Career/Inbox/Inbox";
import Human from "../Page/Products/DivisionWiseDataTable/Human/Human";
import Animal from "../Page/Products/DivisionWiseDataTable/Animal/Animal";
import Herbal from "../Page/Products/DivisionWiseDataTable/Herbal/Herbal";
import Agro from "../Page/Products/DivisionWiseDataTable/Agro/Agro";
import Crop from "../Page/Products/DivisionWiseDataTable/Crop/Crop";
import Garden from "../Page/Products/DivisionWiseDataTable/Garden/Garden";
import Pet from "../Page/Products/DivisionWiseDataTable/Pet/Pet";
import NoticeboardList from "../Page/notice-board/NoticeboardList";
import NoticeboardCreate from "../Page/notice-board/NoticeboardCreate";
import NoticeDetails from "../Page/notice-board/NoticeDetails";
import Profile from "../Page/Profile/Profile";
import Companies from "../Page/Companies/Companies";
import CreateCompany from "../Page/Companies/CreateCompany";
import CompanyDetails from "../Page/Companies/CompanyDetails";
import CvBank from "../Page/CvBank/CvBank";


export const router = createBrowserRouter([
    {
        path: "/",
        element: <Layout/>,
        errorElement: <NotFound/>,
        children: [
            {
                index: true,
                element: <Home/>,
            },
            //
            // COMPANIES MODULE
            //
            {
                index: false,
                element: <Companies/>,
                path: "/companies",
            },
            {
                index: false,
                element: <CreateCompany/>,
                path: "/companies/create",
            },
            {
                index: false,
                element: <CompanyDetails/>,
                path: "/companies/:id",
            },
            //
            // PRODUCTS MODULE
            //
            {
                index: false,
                element: <Human/>,
                path: "/products-human",
            },
            {
                index: false,
                element: <Animal/>,
                path: "/products-animal",
            },
            {
                index: false,
                element: <Crop/>,
                path: "/products-crop-care",
            },
            {
                index: false,
                element: <Herbal/>,
                path: "/products-herbal",
            },
            {
                index: false,
                element: <Agro/>,
                path: "/products-agrobiotech",
            },
            {
                index: false,
                element: <Garden/>,
                path: "/products-garden",
            },
            {
                index: false,
                element: <Pet/>,
                path: "/products-paw-mania",
            },
            {
                element: <ProductDetails/>,
                path: "/products/:id"
            },
            {
                element: <NewProduct/>,
                path: "/products/create"
            },
            //
            // CATEGORIES MODULE
            //
            {
                element: <Categories/>,
                path: "/categories"
            },
            //
            // NEWS AND BLOG MODULES
            //
            {
                element: <InnovationHub/>,
                path: "/innovation-hub"
            },
            {
                element: <InnovationDetails/>,
                path: "/innovation-hub/:id"
            },
            {
                element: <InnovationCreate/>,
                path: "/innovation-hub/create"
            },
            {
                element: <Newsroom/>,
                path: "/newsroom"
            },
            {
                element: <NewsroomCreate/>,
                path: "/newsroom/create"
            },
            {
                element: <NewsroomDetails/>,
                path: "/newsroom/:id"
            },
            //
            // CAREER MODULE
            //
            {
                element: <Career/>,
                path: "/career"
            },
            {
                element: <CreateNew/>,
                path: "/career/create-new"
            },
            {
                element: <CareerDetails/>,
                path: "/career/:id"
            },
            {
                element: <Inbox/>,
                path: "/career/inbox/:id"
            },
            //
            // CV BANK MODULE
            //
            {
                element: <CvBank/>,
                path: "/cv-bank"
            },
            //
            // NOTICEBOARD MODULE
            //
            {
                element: <NoticeboardList/>,
                path: "/notice-board"
            },
            {
                element: <NoticeboardCreate/>,
                path: "/create-notice"
            },
            {
                element: <NoticeDetails/>,
                path: "/notice-details/:id"
            },
            //
            // PROFILE MODULE
            //
            {
                element: <Profile/>,
                path: "/profile"
            },


        ],
    },
    {
        path: "/auth",
        children: [
            {
                path: "login",
                element: <Login/>,
            },
            {
                path: "register",
                element: <Register/>,
            },
            {
                path: "new-password",
                element: <NewPassword/>,
            },
            {
                path: "error",
                element: <Error/>,
            },
            {
                path: "lock-screen",
                element: <LockScreen/>,
            },
            {
                path: "verification",
                element: <Verification/>,
            },
        ],
    },
]);
